import React, {Component} from "react";
import PropTypes from "prop-types";
import Form from 'react-bootstrap/Form';
import ConnectsTo from "../ConnectsTo";
import {Button, InputGroup} from "react-bootstrap";
import {FaRegTrashAlt} from "react-icons/fa";

class Convolver extends Component {
  static propTypes = {
    config: PropTypes.object,
    connectables: PropTypes.array,
    deleteTool: PropTypes.func,
    setToolConfig: PropTypes.func
  }

  constructor(props) {
    super(props);
    this.state = {};

    this.setBuffer = this.setBuffer.bind(this);
    this.setGain = this.setGain.bind(this);
  }

  setBuffer = (event) => {
    this.props.config.buffer = event.target.value;
    this.props.setToolConfig(this.props.config.id, this.props.config);
  }
  setGain = (event) => {
    this.props.config.gain = parseFloat(event.target.value);
    this.props.setToolConfig(this.props.config.id, this.props.config);
  }

  render() {
    return (
        <div className={"convolver toolChainTool"}>
          <h3>Convolver</h3>
          <Button variant={"danger"} onClick={() => {this.props.deleteTool(this.props.config.id)}}><FaRegTrashAlt /></Button>
          <InputGroup>
            <InputGroup.Text>id</InputGroup.Text>
            <Form.Control type="text" value={this.props.config.id}
                          onChange={this.setToolId}/>
          </InputGroup>
          <InputGroup>
            <InputGroup.Text>Buffer</InputGroup.Text>
            <Form.Control
                type="text"
                value={this.props.config.buffer}
                onChange={this.setBuffer}
            />
          </InputGroup>
          <InputGroup>
            <InputGroup.Text>Gain</InputGroup.Text>
            <Form.Control
                type="number"
                value={this.props.config.gain}
                onChange={this.setGain}
            />
          </InputGroup>
          <ConnectsTo
              connectables={this.props.connectables}
              config={this.props.config}
              setToolConfig={this.props.setToolConfig}/>
        </div>
    );
  }
}

export default Convolver;